import { Component } from 'preact'
import Spinner from '../../../../node_modules/spin.js/spin'

class Loader extends Component {
  componentDidMount () {
    const loader = document.querySelector('.full-page-loader')

    const spinnerOptions = {
      lines: 10, // The number of lines to draw
      length: 10, // The length of each line
      width: 3, // The line thickness
      radius: 13, // The radius of the inner circle
      corners: 1, // Corner roundness (0..1)
      rotate: 0, // The rotation offset
      direction: 1, // 1: clockwise, -1: counterclockwise
      color: '#000', // #rgb or #rrggbb or array of colors
      speed: 1, // Rounds per second
      trail: 60, // Afterglow percentage
      shadow: false, // Whether to render a shadow
      hwaccel: false, // Whether to use hardware acceleration
      className: 'spinner', // The CSS class to assign to the spinner
      zIndex: 2e9, // The z-index (defaults to 2000000000)
      top: '50%', // Top position relative to parent
      left: '50%' // Left position relative to parent
    }

    const spinner = new Spinner(spinnerOptions)
    spinner.spin(loader)
  }

  render () {
    return (
      <div class='full-page-loader-background'>
        <div class='full-page-loader' />
      </div>
    )
  }
}

export default Loader
